module.exports = "#map2 {\n  width: 100%;\n  height: 445px;\n  margin-bottom: 30px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/filter-map/filter-map.component.scss
// module id = ./src/app/filter-map/filter-map.component.scss
// module chunks = main